var labelSlot = 'fx_2d2fb1e5_yweuag0';

export { labelSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
